module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__cl_banco_scotiabank_White.4931ddc2.svg";